// utils/maintenance-toolbar.ts

export const createMaintenanceToolbar = (message: string, language: string): HTMLDivElement => {
  const maintenanceDiv = document.createElement('div');
  maintenanceDiv.className = 'tt-maintenance-toolbar-container';

  // SVG
  const svgNS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('width', '24');
  svg.setAttribute('stroke', 'currentColor');
  svg.setAttribute('height', '24');
  svg.setAttribute('viewBox', '0 0 24 24');
  svg.setAttribute('fill', 'none');

  const path = document.createElementNS(svgNS, 'path');
  path.setAttribute(
    'd',
    'M12 9V13M12 17H12.01M21.7299 18.0002L13.7299 4.00022C13.5555 3.69243 13.3025 3.43641 12.9969 3.25829C12.6912 3.08017 12.3437 2.98633 11.9899 2.98633C11.6361 2.98633 11.2887 3.08017 10.983 3.25829C10.6773 3.43641 10.4244 3.69243 10.2499 4.00022L2.24993 18.0002C2.07361 18.3056 1.98116 18.6521 1.98194 19.0047C1.98272 19.3573 2.07671 19.7035 2.25438 20.008C2.43204 20.3126 2.68708 20.5648 2.99362 20.7391C3.30017 20.9133 3.64734 21.0034 3.99993 21.0002H19.9999C20.3508 20.9999 20.6955 20.9072 20.9992 20.7315C21.303 20.5558 21.5551 20.3033 21.7304 19.9993C21.9057 19.6954 21.998 19.3506 21.9979 18.9997C21.9978 18.6488 21.9054 18.3041 21.7299 18.0002Z',
  );
  path.setAttribute('stroke-width', '2');
  path.setAttribute('stroke-linecap', 'round');

  svg.appendChild(path);

  const translations = {
    en: {
      message: 'Maintenance is scheduled for:',
      preventDataLoss: 'To prevent any data loss be sure to not edit/save any data during this time frame.',
    },
    de: {
      message: 'Für folgenden Zeitraum sind Wartungsarbeiten geplant:',
      preventDataLoss:
        'Um Datenverlust zu vermeiden, bitten wir Sie in diesem Zeitraum keine Daten zu speichern/ändern.',
    },
  };

  const languageObject = translations[language] || translations['de'];
  const translatedMessage = languageObject.message;
  const translatedPreventDataLoss = languageObject.preventDataLoss;

  const finalMessage = `${translatedMessage} ${message}. ${translatedPreventDataLoss}`;
  const textNode = document.createTextNode(`${finalMessage}`);

  maintenanceDiv.appendChild(svg);
  maintenanceDiv.appendChild(textNode);

  return maintenanceDiv;
};
